[
  {
    "code" : "11A",
    "name" : "IBC, Metal, for solids",
    "bulk" : false
  },
  {
    "code" : "11B",
    "name" : "IBC, Aluminium, for solids",
    "bulk" : false
  },
  {
    "code" : "11C",
    "name" : "Wooden Ibc, Natural Wood",
    "bulk" : false
  },
  {
    "code" : "11D",
    "name" : "IBC, Plywood, for solids",
    "bulk" : false
  },
  {
    "code" : "11F",
    "name" : "Wooden Ibc, Reconstituted Wood",
    "bulk" : false
  },
  {
    "code" : "11G",
    "name" : "Fibreboard Ibc",
    "bulk" : false
  },
  {
    "code" : "11H",
    "name" : "Rigid Plastics Ibc, For Solids With Un Test Code 11h",
    "bulk" : false
  },
  {
    "code" : "11H1",
    "name" : "IBC, Rigid plastics, for solids",
    "bulk" : false
  },
  {
    "code" : "11H2",
    "name" : "IBC, Rigid plastics, for silids",
    "bulk" : false
  },
  {
    "code" : "11HA1",
    "name" : "Metal Framed Composite Ibc With Plastics Bottle",
    "bulk" : false
  },
  {
    "code" : "11HA2W",
    "name" : "IBC, Composite, with flexible inner receptacle (deviating design)",
    "bulk" : false
  },
  {
    "code" : "11HC2W",
    "name" : "IBC, Composite, with flexible inner receptacle (deviating design)",
    "bulk" : false
  },
  {
    "code" : "11HH1",
    "name" : "Rigid Plastic Receptacle With Outher Plastic",
    "bulk" : false
  },
  {
    "code" : "11HH2",
    "name" : "Rigid Plastic Receptacle With Outer Plastic",
    "bulk" : false
  },
  {
    "code" : "11HZ",
    "name" : "Composite Plastics Ibc / Plastics Inner Rec",
    "bulk" : false
  },
  {
    "code" : "11HZ1",
    "name" : "Composite With Plastic Inner Receptacle, For Solids, Filled Or Discharged By Gravity, With Rigid Plastics Inner Receptacle",
    "bulk" : false
  },
  {
    "code" : "11HZ2",
    "name" : "Composite With Plastic Inner Receptacle, For Solids, Filled Or Discharged By Gravity, With Flexible Plastics Inner Receptacle",
    "bulk" : false
  },
  {
    "code" : "11N",
    "name" : "Metal Ibc, Other Than Aluminium Or Steel, With Un Test Code 11n",
    "bulk" : false
  },
  {
    "code" : "13H",
    "name" : "Woven Plastics Ibc",
    "bulk" : false
  },
  {
    "code" : "13H1",
    "name" : "IBC, Flexible, without coating or liner",
    "bulk" : false
  },
  {
    "code" : "13H2",
    "name" : "IBC, Flexible, coated",
    "bulk" : false
  },
  {
    "code" : "13H3",
    "name" : "IBC, Flexible, with liner",
    "bulk" : false
  },
  {
    "code" : "13H4",
    "name" : "IBC, Flexible, coated and with liner",
    "bulk" : false
  },
  {
    "code" : "13H42",
    "name" : "Woven Plastics Ibc, Coated And With",
    "bulk" : false
  },
  {
    "code" : "13H4W",
    "name" : "13h4w",
    "bulk" : false
  },
  {
    "code" : "13H5",
    "name" : "Plastics, Plastics Film",
    "bulk" : false
  },
  {
    "code" : "13L",
    "name" : "Flexible Ibc, Textile",
    "bulk" : false
  },
  {
    "code" : "13L1",
    "name" : "Textile, Without Coating Or Liner",
    "bulk" : false
  },
  {
    "code" : "13L2",
    "name" : "Textile, Coated",
    "bulk" : false
  },
  {
    "code" : "13L3",
    "name" : "Textile, With Liner",
    "bulk" : false
  },
  {
    "code" : "13L4",
    "name" : "Textile, Coated And With Liner",
    "bulk" : false
  },
  {
    "code" : "13M",
    "name" : "Flexible Ibc, Paper",
    "bulk" : false
  },
  {
    "code" : "13M1",
    "name" : "IBC, Flexible, multiwall paper",
    "bulk" : false
  },
  {
    "code" : "13M2",
    "name" : "IBC, Flexible, multiwall paper, water resistant",
    "bulk" : false
  },
  {
    "code" : "1A",
    "name" : "Drum, steel",
    "bulk" : false
  },
  {
    "code" : "1A1",
    "name" : "Drum, steel with non-removable head",
    "bulk" : false
  },
  {
    "code" : "1A2",
    "name" : "Drum, steel with removable head",
    "bulk" : false
  },
  {
    "code" : "1A2V",
    "name" : "Drum, steel with removable head (special packaging)",
    "bulk" : false
  },
  {
    "code" : "1A2W",
    "name" : "Drum, steel with removable head (deviating design)",
    "bulk" : false
  },
  {
    "code" : "1B",
    "name" : "Drum, aluminium",
    "bulk" : false
  },
  {
    "code" : "1B1",
    "name" : "Drums, Aluminium, Non-removable Head",
    "bulk" : false
  },
  {
    "code" : "1B2",
    "name" : "Drums, Aluminium, Removable Head",
    "bulk" : false
  },
  {
    "code" : "1B2W",
    "name" : "Drum, aluminium with removable head (deviating design)",
    "bulk" : false
  },
  {
    "code" : "1D",
    "name" : "Drum, plywood",
    "bulk" : false
  },
  {
    "code" : "1F",
    "name" : "Container, flexible",
    "bulk" : false
  },
  {
    "code" : "1G",
    "name" : "Drum, fibre",
    "bulk" : false
  },
  {
    "code" : "1H",
    "name" : "Drum, plastic",
    "bulk" : false
  },
  {
    "code" : "1H1",
    "name" : "Drums, Plastics, Non-removable Head",
    "bulk" : false
  },
  {
    "code" : "1H2",
    "name" : "Drum, plastic with removable head",
    "bulk" : false
  },
  {
    "code" : "1H2W",
    "name" : "Drum, plastic with removable head (deviating design)",
    "bulk" : false
  },
  {
    "code" : "1N",
    "name" : "Metal Drum",
    "bulk" : false
  },
  {
    "code" : "1N1",
    "name" : "Metal Drum, Other Than Aluminium Or Steel, Non-removable Head",
    "bulk" : false
  },
  {
    "code" : "1N2",
    "name" : "Metal Drum, Other Than Aluminium Or Steel, Removable Head",
    "bulk" : false
  },
  {
    "code" : "1W",
    "name" : "Drum, wooden",
    "bulk" : false
  },
  {
    "code" : "21A",
    "name" : "IBC, Metal for solids, filled or discharged under pressure",
    "bulk" : false
  },
  {
    "code" : "21B",
    "name" : "Metal Ibc, Aluminium, For Solids With Un Test Code 21b",
    "bulk" : false
  },
  {
    "code" : "21H",
    "name" : "Rigid Plastics Ibc, For Solids With Un Test Code 21h",
    "bulk" : false
  },
  {
    "code" : "21H1",
    "name" : "Rigid Plastics, For Solids, Filled Or Discharged Under Pressure, Fitted With Structural Equipment",
    "bulk" : false
  },
  {
    "code" : "21H2",
    "name" : "Rigid Plastics, For Solids, Filled Or Discharged Under Pressure, Freestanding",
    "bulk" : false
  },
  {
    "code" : "21HA1",
    "name" : "IBC, Metal composite with regid plastics receptacle for solids",
    "bulk" : false
  },
  {
    "code" : "21HH1",
    "name" : "Rigid Plastic With Outer Plastic",
    "bulk" : false
  },
  {
    "code" : "21HH2",
    "name" : "Rigid Plastic With Outer Plastic",
    "bulk" : false
  },
  {
    "code" : "21HZ",
    "name" : "Composite Plastics Ibc With Recepta / Composite Plastics Ibc, Pressure Fi",
    "bulk" : false
  },
  {
    "code" : "21HZ1",
    "name" : "Composite With Plastic Inner Receptacle, For Solids, Filled Or Discharged Under Pressure, With Rigid Plastics Inner Receptacle",
    "bulk" : false
  },
  {
    "code" : "21HZ2",
    "name" : "Composite With Plastic Inner Receptacle, For Solids, Filled Or Discharged Under Pressure, With Flexible Plastics Inner Receptacle",
    "bulk" : false
  },
  {
    "code" : "21N",
    "name" : "Metal Ibc, Other Than Aluminium Or Steel, With Un Test Code 21n",
    "bulk" : false
  },
  {
    "code" : "22TN",
    "name" : "22tn",
    "bulk" : false
  },
  {
    "code" : "2C",
    "name" : "Barrel, wooden",
    "bulk" : false
  },
  {
    "code" : "2C1",
    "name" : "Barrels, Wooden, Bungtype",
    "bulk" : false
  },
  {
    "code" : "2C2",
    "name" : "Barrels, Wooden, Removable Head",
    "bulk" : false
  },
  {
    "code" : "31A",
    "name" : "IBC, Metal for liquids",
    "bulk" : false
  },
  {
    "code" : "31B",
    "name" : "IBC, Aluminium  for liquids",
    "bulk" : false
  },
  {
    "code" : "31H",
    "name" : "Rigid Plastics Ibc",
    "bulk" : false
  },
  {
    "code" : "31H1",
    "name" : "Rigid Plastics, For Liquids, Fitted With Structural Equipment",
    "bulk" : false
  },
  {
    "code" : "31H2",
    "name" : "Rigid Plastics, For Liquids, Freestanding",
    "bulk" : false
  },
  {
    "code" : "31HA",
    "name" : "Composite Ibc With Plastics Inner R",
    "bulk" : false
  },
  {
    "code" : "31HA1",
    "name" : "IBC, Composite for liquids with plastics inner receptacle",
    "bulk" : false
  },
  {
    "code" : "31HA2",
    "name" : "IBC, Composite for liquids with flexible plastics inner receptacle",
    "bulk" : false
  },
  {
    "code" : "31HB",
    "name" : "Composite Ibc With Plastics Inner R",
    "bulk" : false
  },
  {
    "code" : "31HB2",
    "name" : "Composite Aluminium Ibc With Flexib",
    "bulk" : false
  },
  {
    "code" : "31HD",
    "name" : "Composite Ibc With Plastics Inner R",
    "bulk" : false
  },
  {
    "code" : "31HD2",
    "name" : "Composite Plywoord Ibc With Flexible",
    "bulk" : false
  },
  {
    "code" : "31HH",
    "name" : "Composite Ibc With Plastics Inner R",
    "bulk" : false
  },
  {
    "code" : "31HH1",
    "name" : "Composite Ibc With Rigid Plastics I / Composite Plastics Ibs With Rigid R",
    "bulk" : false
  },
  {
    "code" : "31HH2",
    "name" : "Composite Plastics Ibs With Flexibl",
    "bulk" : false
  },
  {
    "code" : "31HN",
    "name" : "Composite Ibc With Plastics Inner R",
    "bulk" : false
  },
  {
    "code" : "31HN2",
    "name" : "Composite Metal Ibc With Flexible P",
    "bulk" : false
  },
  {
    "code" : "31HZ",
    "name" : "Composite With Plastic Inner Receptacle, For Liquids",
    "bulk" : false
  },
  {
    "code" : "31HZ1",
    "name" : "Composite With Plastic Inner Receptacle, For Liquids, With Rigid Plastics Inner Receptacle",
    "bulk" : false
  },
  {
    "code" : "31HZ2",
    "name" : "Composite With Plastic Inner Receptacle, For Liquids, With Flexible Plastics Inner Receptacle",
    "bulk" : false
  },
  {
    "code" : "31N",
    "name" : "Other Than Steel Or Aluminium, For Liquids",
    "bulk" : false
  },
  {
    "code" : "33021010",
    "name" : "Etherische Oliën En Harsaroma's; Parfumerieën, Toiletartikelen En Cosmetische Producten",
    "bulk" : false
  },
  {
    "code" : "3A",
    "name" : "Jerrican, steel",
    "bulk" : false
  },
  {
    "code" : "3A1",
    "name" : "Jerrican, steel with non-removable head",
    "bulk" : false
  },
  {
    "code" : "3A2",
    "name" : "Jerricans, Steel, Removable Head",
    "bulk" : false
  },
  {
    "code" : "3B",
    "name" : "Aluminium Jerricans",
    "bulk" : false
  },
  {
    "code" : "3B1",
    "name" : "Aluminium Jerrican, Non-removable Head",
    "bulk" : false
  },
  {
    "code" : "3B2",
    "name" : "Aluminium Jerrican, Removable Head",
    "bulk" : false
  },
  {
    "code" : "3H",
    "name" : "Jerrican, plastic",
    "bulk" : false
  },
  {
    "code" : "3H1",
    "name" : "Jerricans, Plastics, Non-removable Head",
    "bulk" : false
  },
  {
    "code" : "3H1W",
    "name" : "Jerrican, plastic with non-removable head (deviating design)",
    "bulk" : false
  },
  {
    "code" : "3H2",
    "name" : "Jerrican, plastic with removable head",
    "bulk" : false
  },
  {
    "code" : "3N",
    "name" : "Metal Jerrican, Removable Head",
    "bulk" : false
  },
  {
    "code" : "3N2",
    "name" : "Metal Jerrican, Removable Head",
    "bulk" : false
  },
  {
    "code" : "43",
    "name" : "Bag, super bulk",
    "bulk" : false
  },
  {
    "code" : "44",
    "name" : "Bag, polybag",
    "bulk" : false
  },
  {
    "code" : "4A",
    "name" : "Box, steel",
    "bulk" : false
  },
  {
    "code" : "4AW",
    "name" : "Box, steel (deviating design)",
    "bulk" : false
  },
  {
    "code" : "4B",
    "name" : "Box, aluminium",
    "bulk" : false
  },
  {
    "code" : "4B1",
    "name" : "Box, aluminium",
    "bulk" : false
  },
  {
    "code" : "4BU",
    "name" : "Box, aluminium, the letter \"U\" signifies a special packaging",
    "bulk" : false
  },
  {
    "code" : "4C",
    "name" : "Box, natural wood",
    "bulk" : false
  },
  {
    "code" : "4C1",
    "name" : "Box of natural wood",
    "bulk" : false
  },
  {
    "code" : "4C1W",
    "name" : "Box of natural wood (deviating design)",
    "bulk" : false
  },
  {
    "code" : "4C2",
    "name" : "Boxes, Natural Wood, With Sift-proof Walls",
    "bulk" : false
  },
  {
    "code" : "4D",
    "name" : "Box, plywood",
    "bulk" : false
  },
  {
    "code" : "4D2",
    "name" : "Plywood Boxes",
    "bulk" : false
  },
  {
    "code" : "4DV",
    "name" : "Box, plywood (special packaging)",
    "bulk" : false
  },
  {
    "code" : "4DW",
    "name" : "Box, plywood (deviating design)",
    "bulk" : false
  },
  {
    "code" : "4F",
    "name" : "Box, reconstituted wood",
    "bulk" : false
  },
  {
    "code" : "4G",
    "name" : "Box, fibreboard",
    "bulk" : false
  },
  {
    "code" : "4GV",
    "name" : "Box, fibreboard (special packaging)",
    "bulk" : false
  },
  {
    "code" : "4GW",
    "name" : "Box, fibreboard (deviating design)",
    "bulk" : false
  },
  {
    "code" : "4H",
    "name" : "Box, plastic",
    "bulk" : false
  },
  {
    "code" : "4H1",
    "name" : "Box, plastic expanded",
    "bulk" : false
  },
  {
    "code" : "4H2",
    "name" : "Box, plastic solid",
    "bulk" : false
  },
  {
    "code" : "4H2W",
    "name" : "Box, plastic solid (deviating design)",
    "bulk" : false
  },
  {
    "code" : "50A",
    "name" : "Large packaging of steel",
    "bulk" : false
  },
  {
    "code" : "50B",
    "name" : "Large packaging of aluminium",
    "bulk" : false
  },
  {
    "code" : "50C",
    "name" : "Large packaging of natural wood",
    "bulk" : false
  },
  {
    "code" : "50D",
    "name" : "Large packaging of plywood",
    "bulk" : false
  },
  {
    "code" : "50F",
    "name" : "Large packaging of reconstituted wood           ",
    "bulk" : false
  },
  {
    "code" : "50G",
    "name" : "Large Packagings, Rigid Fibreboard",
    "bulk" : false
  },
  {
    "code" : "50H",
    "name" : "Large packaging of rigid plastics",
    "bulk" : false
  },
  {
    "code" : "50N",
    "name" : "Large packaging of metal",
    "bulk" : false
  },
  {
    "code" : "51H",
    "name" : "Flexible large packaging of plastics",
    "bulk" : false
  },
  {
    "code" : "51M",
    "name" : "Flexible large packaging of paper",
    "bulk" : false
  },
  {
    "code" : "5H",
    "name" : "Bag, woven plastic",
    "bulk" : false
  },
  {
    "code" : "5H1",
    "name" : "Bag, woven plastic without inner lining or coating",
    "bulk" : false
  },
  {
    "code" : "5H2",
    "name" : "Bag, woven plastic, sift-proof",
    "bulk" : false
  },
  {
    "code" : "5H3",
    "name" : "Bag, woven plastic, water resistant",
    "bulk" : false
  },
  {
    "code" : "5H4",
    "name" : "Bag, plastics film",
    "bulk" : false
  },
  {
    "code" : "5L",
    "name" : "Bag, textile",
    "bulk" : false
  },
  {
    "code" : "5L1",
    "name" : "Bags,  Textile, Without Inner Lining Or Coating",
    "bulk" : false
  },
  {
    "code" : "5L2",
    "name" : "Bags,  Textile, Sift-proof",
    "bulk" : false
  },
  {
    "code" : "5L3",
    "name" : "Bags,  Textile, Water Resistant",
    "bulk" : false
  },
  {
    "code" : "5M",
    "name" : "Bag, paper",
    "bulk" : false
  },
  {
    "code" : "5M1",
    "name" : "Bag, paper multiwall",
    "bulk" : false
  },
  {
    "code" : "5M2",
    "name" : "Bag, paper multiwall, water resistant",
    "bulk" : false
  },
  {
    "code" : "6H",
    "name" : "Composite packaging, plastic receptacle",
    "bulk" : false
  },
  {
    "code" : "6HA",
    "name" : "Plastics Receptacle With Outer Stee",
    "bulk" : false
  },
  {
    "code" : "6HA1",
    "name" : "Composite packaging, plastics inner receptacle with outer steel drum",
    "bulk" : false
  },
  {
    "code" : "6HA1W",
    "name" : "Coposite packaging (deviating design",
    "bulk" : false
  },
  {
    "code" : "6HA2",
    "name" : "Composite packaging, plastics inner receptacle with outer steel box",
    "bulk" : false
  },
  {
    "code" : "6HB",
    "name" : "Plastics Receptacle With Outer Alum",
    "bulk" : false
  },
  {
    "code" : "6HB1",
    "name" : "Composite Packagings, Plastics Receptacle, In Aluminium Drum",
    "bulk" : false
  },
  {
    "code" : "6HB2",
    "name" : "Composite Packagings, Plastics Receptacle, In Aluminium Crate Or Box",
    "bulk" : false
  },
  {
    "code" : "6HC",
    "name" : "Composite Packagings, Plastics Receptacle, In Wooden Box",
    "bulk" : false
  },
  {
    "code" : "6HD",
    "name" : "Plastics Receptacle With Outer Plyw",
    "bulk" : false
  },
  {
    "code" : "6HD1",
    "name" : "Composite Packagings, Plastics Receptacle, In Plywood Drum",
    "bulk" : false
  },
  {
    "code" : "6HD2",
    "name" : "Composite Packagings, Plastics Receptacle, In Plywood Box",
    "bulk" : false
  },
  {
    "code" : "6HG",
    "name" : "Plastics Receptacle With Outer Fibr",
    "bulk" : false
  },
  {
    "code" : "6HG1",
    "name" : "Composite Packagings, Plastics Receptacle, In Fibre Drum",
    "bulk" : false
  },
  {
    "code" : "6HG2",
    "name" : "Composite Packagings, Plastics Receptacle, In Fibreboard Box",
    "bulk" : false
  },
  {
    "code" : "6HH",
    "name" : "Plastics Receptacle With Outer Plas",
    "bulk" : false
  },
  {
    "code" : "6HH1",
    "name" : "Composite Packagings, Plastics Receptacle, In Plastics Drum",
    "bulk" : false
  },
  {
    "code" : "6HH2",
    "name" : "Composite Packagings, Plastics Receptacle, In Solid Plastic Box",
    "bulk" : false
  },
  {
    "code" : "6P",
    "name" : "Composite packaging, glass receptacle",
    "bulk" : false
  },
  {
    "code" : "6PA",
    "name" : "Receptacle With Outer Steel",
    "bulk" : false
  },
  {
    "code" : "6PA1",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Steel Drum",
    "bulk" : false
  },
  {
    "code" : "6PA2",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Steel Crate Or Box",
    "bulk" : false
  },
  {
    "code" : "6PB",
    "name" : "Receptacle With Outer Aluminium",
    "bulk" : false
  },
  {
    "code" : "6PB1",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Aluminium Drum",
    "bulk" : false
  },
  {
    "code" : "6PB2",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Aluminium Crate Or Box",
    "bulk" : false
  },
  {
    "code" : "6PC",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, Wooden Box",
    "bulk" : false
  },
  {
    "code" : "6PD",
    "name" : "Receptacle With Outer Plywood",
    "bulk" : false
  },
  {
    "code" : "6PD1",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Plywood Drum",
    "bulk" : false
  },
  {
    "code" : "6PD2",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Wickerwork Hamper",
    "bulk" : false
  },
  {
    "code" : "6PG",
    "name" : "Receptacle With Outer Fibre",
    "bulk" : false
  },
  {
    "code" : "6PG1",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Fibre Drum",
    "bulk" : false
  },
  {
    "code" : "6PG2",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Fibreboard Box",
    "bulk" : false
  },
  {
    "code" : "6PH",
    "name" : "Receptacle With Outer Plastics / Receptacle With Outer Plastics Pack",
    "bulk" : false
  },
  {
    "code" : "6PH1",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Expanded Plastics Packagings",
    "bulk" : false
  },
  {
    "code" : "6PH2",
    "name" : "Composite Packagings, Glass, Porcelain Or Stoneware Receptacle, In Solid Plastics Packaging",
    "bulk" : false
  },
  {
    "code" : "7A",
    "name" : "Case, car",
    "bulk" : false
  },
  {
    "code" : "7B",
    "name" : "Case, wooden",
    "bulk" : false
  },
  {
    "code" : "8A",
    "name" : "Pallet, wooden",
    "bulk" : false
  },
  {
    "code" : "8B",
    "name" : "Crate, wooden",
    "bulk" : false
  },
  {
    "code" : "8C",
    "name" : "Bundle, wooden",
    "bulk" : false
  },
  {
    "code" : "AA",
    "name" : "Intermediate bulk container, rigid plastic",
    "bulk" : false
  },
  {
    "code" : "AB",
    "name" : "Receptacle, fibre",
    "bulk" : false
  },
  {
    "code" : "AC",
    "name" : "Receptacle, paper",
    "bulk" : false
  },
  {
    "code" : "AD",
    "name" : "Receptacle, wooden",
    "bulk" : false
  },
  {
    "code" : "AE",
    "name" : "Aerosol",
    "bulk" : false
  },
  {
    "code" : "AF",
    "name" : "Pallet, modular, collars 80cms * 60cms",
    "bulk" : false
  },
  {
    "code" : "AG",
    "name" : "Pallet, shrinkwrapped",
    "bulk" : false
  },
  {
    "code" : "AH",
    "name" : "Pallet, 100cms * 110cms",
    "bulk" : false
  },
  {
    "code" : "AI",
    "name" : "Clamshell",
    "bulk" : false
  },
  {
    "code" : "AJ",
    "name" : "Cone",
    "bulk" : false
  },
  {
    "code" : "AL",
    "name" : "Ball",
    "bulk" : false
  },
  {
    "code" : "AM",
    "name" : "Ampoule, non-protected",
    "bulk" : false
  },
  {
    "code" : "AP",
    "name" : "Ampoule, protected",
    "bulk" : false
  },
  {
    "code" : "AT",
    "name" : "Atomizer",
    "bulk" : false
  },
  {
    "code" : "AV",
    "name" : "Capsule",
    "bulk" : false
  },
  {
    "code" : "B4",
    "name" : "Belt",
    "bulk" : false
  },
  {
    "code" : "BA",
    "name" : "Barrel",
    "bulk" : false
  },
  {
    "code" : "BB",
    "name" : "Bobbin",
    "bulk" : false
  },
  {
    "code" : "BC",
    "name" : "Bottlecrate / bottlerack",
    "bulk" : false
  },
  {
    "code" : "BD",
    "name" : "Board",
    "bulk" : false
  },
  {
    "code" : "BE",
    "name" : "Bundle",
    "bulk" : false
  },
  {
    "code" : "BF",
    "name" : "Balloon, non-protected",
    "bulk" : false
  },
  {
    "code" : "BG",
    "name" : "Bag",
    "bulk" : false
  },
  {
    "code" : "BH",
    "name" : "Bunch",
    "bulk" : false
  },
  {
    "code" : "BI",
    "name" : "Bin",
    "bulk" : false
  },
  {
    "code" : "BJ",
    "name" : "Bucket",
    "bulk" : false
  },
  {
    "code" : "BK",
    "name" : "Basket",
    "bulk" : false
  },
  {
    "code" : "BL",
    "name" : "Bale, compressed",
    "bulk" : false
  },
  {
    "code" : "BM",
    "name" : "Basin",
    "bulk" : false
  },
  {
    "code" : "BN",
    "name" : "Bale, non-compressed",
    "bulk" : false
  },
  {
    "code" : "BO",
    "name" : "Bottle, non-protected, cylindrical",
    "bulk" : false
  },
  {
    "code" : "BP",
    "name" : "Balloon, protected",
    "bulk" : false
  },
  {
    "code" : "BQ",
    "name" : "Bottle, protected cylindrical",
    "bulk" : false
  },
  {
    "code" : "BR",
    "name" : "Bar",
    "bulk" : false
  },
  {
    "code" : "BS",
    "name" : "Bottle, non-protected, bulbous",
    "bulk" : false
  },
  {
    "code" : "BT",
    "name" : "Bolt",
    "bulk" : false
  },
  {
    "code" : "BU",
    "name" : "Butt",
    "bulk" : false
  },
  {
    "code" : "BV",
    "name" : "Bottle, protected bulbous",
    "bulk" : false
  },
  {
    "code" : "BW",
    "name" : "Box, for liquids",
    "bulk" : false
  },
  {
    "code" : "BX",
    "name" : "Box",
    "bulk" : false
  },
  {
    "code" : "BY",
    "name" : "Board, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "BZ",
    "name" : "Bars, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "CA",
    "name" : "Can, rectangular",
    "bulk" : false
  },
  {
    "code" : "CB",
    "name" : "Crate, beer",
    "bulk" : false
  },
  {
    "code" : "CC",
    "name" : "Churn",
    "bulk" : false
  },
  {
    "code" : "CD",
    "name" : "Can, with handle and spout",
    "bulk" : false
  },
  {
    "code" : "CE",
    "name" : "Creel",
    "bulk" : false
  },
  {
    "code" : "CF",
    "name" : "Coffer",
    "bulk" : false
  },
  {
    "code" : "CG",
    "name" : "Cage",
    "bulk" : false
  },
  {
    "code" : "CH",
    "name" : "Chest",
    "bulk" : false
  },
  {
    "code" : "CI",
    "name" : "Canister",
    "bulk" : false
  },
  {
    "code" : "CJ",
    "name" : "Coffin",
    "bulk" : false
  },
  {
    "code" : "CK",
    "name" : "Cask",
    "bulk" : false
  },
  {
    "code" : "CL",
    "name" : "Coil",
    "bulk" : false
  },
  {
    "code" : "CM",
    "name" : "Card",
    "bulk" : false
  },
  {
    "code" : "CN",
    "name" : "Container, not otherwise specified as transport equipment",
    "bulk" : false
  },
  {
    "code" : "CO",
    "name" : "Carboy, non-protected",
    "bulk" : false
  },
  {
    "code" : "CP",
    "name" : "Carboy, protected",
    "bulk" : false
  },
  {
    "code" : "CQ",
    "name" : "Cartridge",
    "bulk" : false
  },
  {
    "code" : "CR",
    "name" : "Crate",
    "bulk" : false
  },
  {
    "code" : "CS",
    "name" : "Case",
    "bulk" : false
  },
  {
    "code" : "CT",
    "name" : "Carton",
    "bulk" : false
  },
  {
    "code" : "CTS",
    "name" : "Ctns",
    "bulk" : false
  },
  {
    "code" : "CU",
    "name" : "Cup",
    "bulk" : false
  },
  {
    "code" : "CV",
    "name" : "Cover",
    "bulk" : false
  },
  {
    "code" : "CW",
    "name" : "Cage, roll",
    "bulk" : false
  },
  {
    "code" : "CX",
    "name" : "Can, cylindrical",
    "bulk" : false
  },
  {
    "code" : "CY",
    "name" : "Cylinder",
    "bulk" : false
  },
  {
    "code" : "CYS",
    "name" : "Cyls",
    "bulk" : false
  },
  {
    "code" : "CZ",
    "name" : "Canvas",
    "bulk" : false
  },
  {
    "code" : "DA",
    "name" : "Crate, multiple layer, plastic",
    "bulk" : false
  },
  {
    "code" : "DB",
    "name" : "Crate, multiple layer, wooden",
    "bulk" : false
  },
  {
    "code" : "DC",
    "name" : "Crate, multiple layer, cardboard",
    "bulk" : false
  },
  {
    "code" : "DG",
    "name" : "Cage, Commonwealth Handling Equipment Pool  (CHEP)",
    "bulk" : false
  },
  {
    "code" : "DH",
    "name" : "Box, Commonwealth Handling Equipment Pool (CHEP), Eurobox",
    "bulk" : false
  },
  {
    "code" : "DI",
    "name" : "Drum, iron",
    "bulk" : false
  },
  {
    "code" : "DJ",
    "name" : "Demijohn, non-protected",
    "bulk" : false
  },
  {
    "code" : "DK",
    "name" : "Crate, bulk, cardboard",
    "bulk" : false
  },
  {
    "code" : "DL",
    "name" : "Crate, bulk, plastic",
    "bulk" : false
  },
  {
    "code" : "DM",
    "name" : "Crate, bulk, wooden",
    "bulk" : false
  },
  {
    "code" : "DN",
    "name" : "Dispenser",
    "bulk" : false
  },
  {
    "code" : "DP",
    "name" : "Demijohn, protected",
    "bulk" : false
  },
  {
    "code" : "DR",
    "name" : "Drum",
    "bulk" : false
  },
  {
    "code" : "DS",
    "name" : "Tray, one layer no cover, plastic",
    "bulk" : false
  },
  {
    "code" : "DT",
    "name" : "Tray, one layer no cover, wooden",
    "bulk" : false
  },
  {
    "code" : "DU",
    "name" : "Tray, one layer no cover, polystyrene",
    "bulk" : false
  },
  {
    "code" : "DV",
    "name" : "Tray, one layer no cover, cardboard",
    "bulk" : false
  },
  {
    "code" : "DW",
    "name" : "Tray, two layers no cover, plastic tray",
    "bulk" : false
  },
  {
    "code" : "DX",
    "name" : "Tray, two layers no cover, wooden",
    "bulk" : false
  },
  {
    "code" : "DY",
    "name" : "Tray, two layers no cover, cardboard",
    "bulk" : false
  },
  {
    "code" : "EC",
    "name" : "Bag, plastic",
    "bulk" : false
  },
  {
    "code" : "ED",
    "name" : "Case, with pallet base",
    "bulk" : false
  },
  {
    "code" : "EE",
    "name" : "Case, with pallet base, wooden",
    "bulk" : false
  },
  {
    "code" : "EF",
    "name" : "Case, with pallet base, cardboard",
    "bulk" : false
  },
  {
    "code" : "EG",
    "name" : "Case, with pallet base, plastic",
    "bulk" : false
  },
  {
    "code" : "EH",
    "name" : "Case, with pallet base, metal",
    "bulk" : false
  },
  {
    "code" : "EI",
    "name" : "Case, isothermic",
    "bulk" : false
  },
  {
    "code" : "EN",
    "name" : "Envelope",
    "bulk" : false
  },
  {
    "code" : "FB",
    "name" : "Flexibag",
    "bulk" : false
  },
  {
    "code" : "FC",
    "name" : "Crate, fruit",
    "bulk" : false
  },
  {
    "code" : "FD",
    "name" : "Crate, framed",
    "bulk" : false
  },
  {
    "code" : "FE",
    "name" : "Flexitank",
    "bulk" : false
  },
  {
    "code" : "FI",
    "name" : "Firkin",
    "bulk" : false
  },
  {
    "code" : "FL",
    "name" : "Flask",
    "bulk" : false
  },
  {
    "code" : "FO",
    "name" : "Footlocker",
    "bulk" : false
  },
  {
    "code" : "FP",
    "name" : "Filmpack",
    "bulk" : false
  },
  {
    "code" : "FR",
    "name" : "Frame",
    "bulk" : false
  },
  {
    "code" : "FT",
    "name" : "Foodtainer",
    "bulk" : false
  },
  {
    "code" : "FW",
    "name" : "Cart, flatbed",
    "bulk" : false
  },
  {
    "code" : "FX",
    "name" : "Bag, flexible container",
    "bulk" : false
  },
  {
    "code" : "GB",
    "name" : "Bottle, gas",
    "bulk" : false
  },
  {
    "code" : "GI",
    "name" : "Girder",
    "bulk" : false
  },
  {
    "code" : "GL",
    "name" : "Container, gallon",
    "bulk" : false
  },
  {
    "code" : "GR",
    "name" : "Receptacle, glass",
    "bulk" : false
  },
  {
    "code" : "GU",
    "name" : "Tray, containing horizontally stacked flat items",
    "bulk" : false
  },
  {
    "code" : "GY",
    "name" : "Bag, gunny",
    "bulk" : false
  },
  {
    "code" : "GZ",
    "name" : "Girders, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "HA",
    "name" : "Basket, with handle, plastic",
    "bulk" : false
  },
  {
    "code" : "HB",
    "name" : "Basket, with handle, wooden",
    "bulk" : false
  },
  {
    "code" : "HC",
    "name" : "Basket, with handle, cardboard",
    "bulk" : false
  },
  {
    "code" : "HG",
    "name" : "Hogshead",
    "bulk" : false
  },
  {
    "code" : "HN",
    "name" : "Hanger",
    "bulk" : false
  },
  {
    "code" : "HR",
    "name" : "Hamper",
    "bulk" : false
  },
  {
    "code" : "IA",
    "name" : "Package, display, wooden",
    "bulk" : false
  },
  {
    "code" : "IB",
    "name" : "Package, display, cardboard",
    "bulk" : false
  },
  {
    "code" : "IBC",
    "name" : "Ibc",
    "bulk" : false
  },
  {
    "code" : "IC",
    "name" : "Package, display, plastic",
    "bulk" : false
  },
  {
    "code" : "ID",
    "name" : "Package, display, metal",
    "bulk" : false
  },
  {
    "code" : "IE",
    "name" : "Package, show",
    "bulk" : false
  },
  {
    "code" : "IF",
    "name" : "Package, flow",
    "bulk" : false
  },
  {
    "code" : "IG",
    "name" : "Package, paper wrapped",
    "bulk" : false
  },
  {
    "code" : "IH",
    "name" : "Drum, plastic",
    "bulk" : false
  },
  {
    "code" : "IK",
    "name" : "Package, cardboard, with bottle grip-holes",
    "bulk" : false
  },
  {
    "code" : "IL",
    "name" : "Tray, rigid, lidded stackable (CEN TS 14482:2002)",
    "bulk" : false
  },
  {
    "code" : "IN",
    "name" : "Ingot",
    "bulk" : false
  },
  {
    "code" : "IZ",
    "name" : "Ingots, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "JB",
    "name" : "Bag, jumbo",
    "bulk" : false
  },
  {
    "code" : "JC",
    "name" : "Jerrican, rectangular",
    "bulk" : false
  },
  {
    "code" : "JG",
    "name" : "Jug",
    "bulk" : false
  },
  {
    "code" : "JR",
    "name" : "Jar",
    "bulk" : false
  },
  {
    "code" : "JT",
    "name" : "Jutebag",
    "bulk" : false
  },
  {
    "code" : "JY",
    "name" : "Jerrican, cylindrical",
    "bulk" : false
  },
  {
    "code" : "KG",
    "name" : "Keg",
    "bulk" : false
  },
  {
    "code" : "KI",
    "name" : "Kit",
    "bulk" : false
  },
  {
    "code" : "LE",
    "name" : "Luggage",
    "bulk" : false
  },
  {
    "code" : "LG",
    "name" : "Log",
    "bulk" : false
  },
  {
    "code" : "LT",
    "name" : "Lot",
    "bulk" : false
  },
  {
    "code" : "LU",
    "name" : "Lug",
    "bulk" : false
  },
  {
    "code" : "LV",
    "name" : "Liftvan",
    "bulk" : false
  },
  {
    "code" : "LZ",
    "name" : "Logs, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "MA",
    "name" : "Crate, metal",
    "bulk" : false
  },
  {
    "code" : "MB",
    "name" : "Bag, multiply",
    "bulk" : false
  },
  {
    "code" : "MC",
    "name" : "Crate, milk",
    "bulk" : false
  },
  {
    "code" : "ME",
    "name" : "Container, metal",
    "bulk" : false
  },
  {
    "code" : "MR",
    "name" : "Receptacle, metal",
    "bulk" : false
  },
  {
    "code" : "MS",
    "name" : "Sack, multi-wall",
    "bulk" : false
  },
  {
    "code" : "MT",
    "name" : "Mat",
    "bulk" : false
  },
  {
    "code" : "MW",
    "name" : "Receptacle, plastic wrapped",
    "bulk" : false
  },
  {
    "code" : "MX",
    "name" : "Matchbox",
    "bulk" : false
  },
  {
    "code" : "NA",
    "name" : "Not available",
    "bulk" : false
  },
  {
    "code" : "NE",
    "name" : "Unpacked or unpackaged",
    "bulk" : false
  },
  {
    "code" : "NF",
    "name" : "Unpacked or unpackaged, single unit",
    "bulk" : false
  },
  {
    "code" : "NG",
    "name" : "Unpacked or unpackaged, multiple units",
    "bulk" : false
  },
  {
    "code" : "NS",
    "name" : "Nest",
    "bulk" : false
  },
  {
    "code" : "NT",
    "name" : "Net",
    "bulk" : false
  },
  {
    "code" : "NU",
    "name" : "Net, tube, plastic",
    "bulk" : false
  },
  {
    "code" : "NV",
    "name" : "Net, tube, textile",
    "bulk" : false
  },
  {
    "code" : "OA",
    "name" : "Pallet, CHEP 40 cm x 60 cm",
    "bulk" : false
  },
  {
    "code" : "OB",
    "name" : "Pallet, CHEP 80 cm x 120 cm",
    "bulk" : false
  },
  {
    "code" : "OC",
    "name" : "Pallet, CHEP 100 cm x 120 cm",
    "bulk" : false
  },
  {
    "code" : "OD",
    "name" : "Pallet, AS 4068-1993",
    "bulk" : false
  },
  {
    "code" : "OE",
    "name" : "Pallet, ISO T11",
    "bulk" : false
  },
  {
    "code" : "OF",
    "name" : "Platform, unspecified weight or dimension",
    "bulk" : false
  },
  {
    "code" : "OK",
    "name" : "Block",
    "bulk" : false
  },
  {
    "code" : "OT",
    "name" : "Octabin",
    "bulk" : false
  },
  {
    "code" : "OU",
    "name" : "Container, outer",
    "bulk" : false
  },
  {
    "code" : "P2",
    "name" : "Pan",
    "bulk" : false
  },
  {
    "code" : "PA",
    "name" : "Packet",
    "bulk" : false
  },
  {
    "code" : "PAIL",
    "name" : "Pail",
    "bulk" : false
  },
  {
    "code" : "PB",
    "name" : "Pallet, box Combined open-ended box and pallet",
    "bulk" : false
  },
  {
    "code" : "PC",
    "name" : "Parcel",
    "bulk" : false
  },
  {
    "code" : "PD",
    "name" : "Pallet, modular, collars 80cms * 100cms",
    "bulk" : false
  },
  {
    "code" : "PE",
    "name" : "Pallet, modular, collars 80cms * 120cms",
    "bulk" : false
  },
  {
    "code" : "PF",
    "name" : "Pen",
    "bulk" : false
  },
  {
    "code" : "PG",
    "name" : "Plate",
    "bulk" : false
  },
  {
    "code" : "PH",
    "name" : "Pitcher",
    "bulk" : false
  },
  {
    "code" : "PI",
    "name" : "Pipe",
    "bulk" : false
  },
  {
    "code" : "PJ",
    "name" : "Punnet",
    "bulk" : false
  },
  {
    "code" : "PK",
    "name" : "Package",
    "bulk" : false
  },
  {
    "code" : "PL",
    "name" : "Pail",
    "bulk" : false
  },
  {
    "code" : "PN",
    "name" : "Plank",
    "bulk" : false
  },
  {
    "code" : "PO",
    "name" : "Pouch",
    "bulk" : false
  },
  {
    "code" : "PP",
    "name" : "Piece",
    "bulk" : false
  },
  {
    "code" : "PR",
    "name" : "Receptacle, plastic",
    "bulk" : false
  },
  {
    "code" : "PRCT",
    "name" : "Pressure Receptacles",
    "bulk" : false
  },
  {
    "code" : "PT",
    "name" : "Pot",
    "bulk" : false
  },
  {
    "code" : "PU",
    "name" : "Tray",
    "bulk" : false
  },
  {
    "code" : "PV",
    "name" : "Pipes, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "PX",
    "name" : "Pallet",
    "bulk" : false
  },
  {
    "code" : "PY",
    "name" : "Plates, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "PZ",
    "name" : "Planks, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "QA",
    "name" : "Drum, steel, non-removable head",
    "bulk" : false
  },
  {
    "code" : "QB",
    "name" : "Drum, steel, removable head",
    "bulk" : false
  },
  {
    "code" : "QC",
    "name" : "Drum, aluminium, non-removable head",
    "bulk" : false
  },
  {
    "code" : "QD",
    "name" : "Drum, aluminium, removable head",
    "bulk" : false
  },
  {
    "code" : "QF",
    "name" : "Drum, plastic, non-removable head",
    "bulk" : false
  },
  {
    "code" : "QG",
    "name" : "Drum, plastic, removable head",
    "bulk" : false
  },
  {
    "code" : "QH",
    "name" : "Barrel, wooden, bung type",
    "bulk" : false
  },
  {
    "code" : "QJ",
    "name" : "Barrel, wooden, removable head",
    "bulk" : false
  },
  {
    "code" : "QK",
    "name" : "Jerrican, steel, non-removable head",
    "bulk" : false
  },
  {
    "code" : "QL",
    "name" : "Jerrican, steel, removable head",
    "bulk" : false
  },
  {
    "code" : "QM",
    "name" : "Jerrican, plastic, non-removable head",
    "bulk" : false
  },
  {
    "code" : "QN",
    "name" : "Jerrican, plastic, removable head",
    "bulk" : false
  },
  {
    "code" : "QP",
    "name" : "Box, wooden, natural wood, ordinary",
    "bulk" : false
  },
  {
    "code" : "QQ",
    "name" : "Box, wooden, natural wood, with sift proof walls",
    "bulk" : false
  },
  {
    "code" : "QR",
    "name" : "Box, plastic, expanded",
    "bulk" : false
  },
  {
    "code" : "QS",
    "name" : "Box, plastic, solid",
    "bulk" : false
  },
  {
    "code" : "RD",
    "name" : "Rod",
    "bulk" : false
  },
  {
    "code" : "RG",
    "name" : "Ring",
    "bulk" : false
  },
  {
    "code" : "RJ",
    "name" : "Rack, clothing hanger",
    "bulk" : false
  },
  {
    "code" : "RK",
    "name" : "Rack",
    "bulk" : false
  },
  {
    "code" : "RL",
    "name" : "Reel",
    "bulk" : false
  },
  {
    "code" : "RO",
    "name" : "Roll",
    "bulk" : false
  },
  {
    "code" : "RT",
    "name" : "Rednet",
    "bulk" : false
  },
  {
    "code" : "RZ",
    "name" : "Rods, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "SA",
    "name" : "Sack",
    "bulk" : false
  },
  {
    "code" : "SB",
    "name" : "Slab",
    "bulk" : false
  },
  {
    "code" : "SC",
    "name" : "Crate, shallow",
    "bulk" : false
  },
  {
    "code" : "SD",
    "name" : "Spindle",
    "bulk" : false
  },
  {
    "code" : "SE",
    "name" : "Sea-chest",
    "bulk" : false
  },
  {
    "code" : "SH",
    "name" : "Sachet",
    "bulk" : false
  },
  {
    "code" : "SI",
    "name" : "Skid",
    "bulk" : false
  },
  {
    "code" : "SK",
    "name" : "Case, skeleton",
    "bulk" : false
  },
  {
    "code" : "SL",
    "name" : "Slipsheet",
    "bulk" : false
  },
  {
    "code" : "SM",
    "name" : "Sheetmetal",
    "bulk" : false
  },
  {
    "code" : "SO",
    "name" : "Spool",
    "bulk" : false
  },
  {
    "code" : "SP",
    "name" : "Sheet, plastic wrapping",
    "bulk" : false
  },
  {
    "code" : "SS",
    "name" : "Case, steel",
    "bulk" : false
  },
  {
    "code" : "ST",
    "name" : "Sheet",
    "bulk" : false
  },
  {
    "code" : "SU",
    "name" : "Suitcase",
    "bulk" : false
  },
  {
    "code" : "SV",
    "name" : "Envelope, steel",
    "bulk" : false
  },
  {
    "code" : "SW",
    "name" : "Shrinkwrapped",
    "bulk" : false
  },
  {
    "code" : "SX",
    "name" : "Set",
    "bulk" : false
  },
  {
    "code" : "SY",
    "name" : "Sleeve",
    "bulk" : false
  },
  {
    "code" : "SZ",
    "name" : "Sheets, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "T1",
    "name" : "Tablet",
    "bulk" : false
  },
  {
    "code" : "T22",
    "name" : "T22",
    "bulk" : false
  },
  {
    "code" : "T34",
    "name" : "Ferrosilicon With 30 % Or More Butless Than 90 Silicon",
    "bulk" : false
  },
  {
    "code" : "TB",
    "name" : "Tub",
    "bulk" : false
  },
  {
    "code" : "TC",
    "name" : "Tea-chest",
    "bulk" : false
  },
  {
    "code" : "TD",
    "name" : "Tube, collapsible",
    "bulk" : false
  },
  {
    "code" : "TE",
    "name" : "Tyre",
    "bulk" : false
  },
  {
    "code" : "TG",
    "name" : "Tank container, generic",
    "bulk" : false
  },
  {
    "code" : "TI",
    "name" : "Tierce",
    "bulk" : false
  },
  {
    "code" : "TK",
    "name" : "Tank, rectangular",
    "bulk" : false
  },
  {
    "code" : "TL",
    "name" : "Tub, with lid",
    "bulk" : false
  },
  {
    "code" : "TN",
    "name" : "Tin",
    "bulk" : false
  },
  {
    "code" : "TNK",
    "name" : "Portable Tank",
    "bulk" : false
  },
  {
    "code" : "TO",
    "name" : "Tun",
    "bulk" : false
  },
  {
    "code" : "TR",
    "name" : "Trunk",
    "bulk" : false
  },
  {
    "code" : "TS",
    "name" : "Truss",
    "bulk" : false
  },
  {
    "code" : "TT",
    "name" : "Bag, tote",
    "bulk" : false
  },
  {
    "code" : "TU",
    "name" : "Tube",
    "bulk" : false
  },
  {
    "code" : "TV",
    "name" : "Tube, with nozzle",
    "bulk" : false
  },
  {
    "code" : "TW",
    "name" : "Pallet, triwall",
    "bulk" : false
  },
  {
    "code" : "TY",
    "name" : "Tank, cylindrical",
    "bulk" : false
  },
  {
    "code" : "TZ",
    "name" : "Tubes, in bundle/bunch/truss",
    "bulk" : false
  },
  {
    "code" : "UC",
    "name" : "Uncaged",
    "bulk" : false
  },
  {
    "code" : "UN",
    "name" : "Unit",
    "bulk" : false
  },
  {
    "code" : "UNIT",
    "name" : "Overpack, Unit Load, Pallet Box, Cr",
    "bulk" : false
  },
  {
    "code" : "UNPV",
    "name" : "1 Unpack Veh",
    "bulk" : false
  },
  {
    "code" : "UT",
    "name" : "Vehicle",
    "bulk" : false
  },
  {
    "code" : "VA",
    "name" : "Vat",
    "bulk" : false
  },
  {
    "code" : "VG",
    "name" : "Bulk, gas (at 1031 mbar and 15°C)",
    "bulk" : true
  },
  {
    "code" : "VI",
    "name" : "Vial",
    "bulk" : false
  },
  {
    "code" : "VK",
    "name" : "Vanpack",
    "bulk" : false
  },
  {
    "code" : "VL",
    "name" : "Bulk, liquid",
    "bulk" : true
  },
  {
    "code" : "VN",
    "name" : "Vehicle",
    "bulk" : false
  },
  {
    "code" : "VO",
    "name" : "Bulk, solid, large particles (nodules)",
    "bulk" : true
  },
  {
    "code" : "VP",
    "name" : "Vacuum-packed",
    "bulk" : false
  },
  {
    "code" : "VQ",
    "name" : "Bulk, liquefied gas (at abnormal temperature/pressure)",
    "bulk" : true
  },
  {
    "code" : "VR",
    "name" : "Bulk, solid, granular particles (grains)",
    "bulk" : true
  },
  {
    "code" : "VS",
    "name" : "Bulk, scrap metal",
    "bulk" : true
  },
  {
    "code" : "VY",
    "name" : "Bulk, solid, fine particles (powders)",
    "bulk" : true
  },
  {
    "code" : "WA",
    "name" : "Intermediate bulk container",
    "bulk" : false
  },
  {
    "code" : "WB",
    "name" : "Wickerbottle",
    "bulk" : false
  },
  {
    "code" : "WC",
    "name" : "Intermediate bulk container, steel",
    "bulk" : false
  },
  {
    "code" : "WD",
    "name" : "Intermediate bulk container, aluminium",
    "bulk" : false
  },
  {
    "code" : "WF",
    "name" : "Intermediate bulk container, metal",
    "bulk" : false
  },
  {
    "code" : "WG",
    "name" : "Intermediate bulk container, steel, pressurised > 10 kpa",
    "bulk" : false
  },
  {
    "code" : "WH",
    "name" : "Intermediate bulk container, aluminium, pressurised > 10 kpa",
    "bulk" : false
  },
  {
    "code" : "WJ",
    "name" : "Intermediate bulk container, metal, pressure 10 kpa",
    "bulk" : false
  },
  {
    "code" : "WK",
    "name" : "Intermediate bulk container, steel, liquid",
    "bulk" : false
  },
  {
    "code" : "WL",
    "name" : "Intermediate bulk container, aluminium, liquid",
    "bulk" : false
  },
  {
    "code" : "WM",
    "name" : "Intermediate bulk container, metal, liquid",
    "bulk" : false
  },
  {
    "code" : "WN",
    "name" : "Intermediate bulk container, woven plastic, without coat/liner",
    "bulk" : false
  },
  {
    "code" : "WP",
    "name" : "Intermediate bulk container, woven plastic, coated",
    "bulk" : false
  },
  {
    "code" : "WQ",
    "name" : "Intermediate bulk container, woven plastic, with liner",
    "bulk" : false
  },
  {
    "code" : "WR",
    "name" : "Intermediate bulk container, woven plastic, coated and liner",
    "bulk" : false
  },
  {
    "code" : "WS",
    "name" : "Intermediate bulk container, plastic film",
    "bulk" : false
  },
  {
    "code" : "WT",
    "name" : "Intermediate bulk container, textile with out coat/liner",
    "bulk" : false
  },
  {
    "code" : "WU",
    "name" : "Intermediate bulk container, natural wood, with inner liner",
    "bulk" : false
  },
  {
    "code" : "WV",
    "name" : "Intermediate bulk container, textile, coated",
    "bulk" : false
  },
  {
    "code" : "WW",
    "name" : "Intermediate bulk container, textile, with liner",
    "bulk" : false
  },
  {
    "code" : "WX",
    "name" : "Intermediate bulk container, textile, coated and liner",
    "bulk" : false
  },
  {
    "code" : "WY",
    "name" : "Intermediate bulk container, plywood, with inner liner",
    "bulk" : false
  },
  {
    "code" : "WZ",
    "name" : "Intermediate bulk container, reconstituted wood, with inner liner",
    "bulk" : false
  },
  {
    "code" : "XA",
    "name" : "Bag, woven plastic, without inner coat/liner",
    "bulk" : false
  },
  {
    "code" : "XB",
    "name" : "Bag, woven plastic, sift proof",
    "bulk" : false
  },
  {
    "code" : "XC",
    "name" : "Bag, woven plastic, water resistant",
    "bulk" : false
  },
  {
    "code" : "XD",
    "name" : "Bag, plastics film",
    "bulk" : false
  },
  {
    "code" : "XF",
    "name" : "Bag, textile, without inner coat/liner",
    "bulk" : false
  },
  {
    "code" : "XG",
    "name" : "Bag, textile, sift proof",
    "bulk" : false
  },
  {
    "code" : "XH",
    "name" : "Bag, textile, water resistant",
    "bulk" : false
  },
  {
    "code" : "XJ",
    "name" : "Bag, paper, multi-wall",
    "bulk" : false
  },
  {
    "code" : "XK",
    "name" : "Bag, paper, multi-wall, water resistant",
    "bulk" : false
  },
  {
    "code" : "YA",
    "name" : "Composite packaging, plastic receptacle in steel drum",
    "bulk" : false
  },
  {
    "code" : "YB",
    "name" : "Composite packaging, plastic receptacle in steel crate box",
    "bulk" : false
  },
  {
    "code" : "YC",
    "name" : "Composite packaging, plastic receptacle in aluminium drum",
    "bulk" : false
  },
  {
    "code" : "YD",
    "name" : "Composite packaging, plastic receptacle in aluminium crate",
    "bulk" : false
  },
  {
    "code" : "YF",
    "name" : "Composite packaging, plastic receptacle in wooden box",
    "bulk" : false
  },
  {
    "code" : "YG",
    "name" : "Composite packaging, plastic receptacle in plywood drum",
    "bulk" : false
  },
  {
    "code" : "YH",
    "name" : "Composite packaging, plastic receptacle in plywood box",
    "bulk" : false
  },
  {
    "code" : "YJ",
    "name" : "Composite packaging, plastic receptacle in fibre drum",
    "bulk" : false
  },
  {
    "code" : "YK",
    "name" : "Composite packaging, plastic receptacle in fibreboard box",
    "bulk" : false
  },
  {
    "code" : "YL",
    "name" : "Composite packaging, plastic receptacle in plastic drum",
    "bulk" : false
  },
  {
    "code" : "YM",
    "name" : "Composite packaging, plastic receptacle in solid plastic box",
    "bulk" : false
  },
  {
    "code" : "YN",
    "name" : "Composite packaging, glass receptacle in steel drum",
    "bulk" : false
  },
  {
    "code" : "YP",
    "name" : "Composite packaging, glass receptacle in steel crate box",
    "bulk" : false
  },
  {
    "code" : "YQ",
    "name" : "Composite packaging, glass receptacle in aluminium drum",
    "bulk" : false
  },
  {
    "code" : "YR",
    "name" : "Composite packaging, glass receptacle in aluminium crate",
    "bulk" : false
  },
  {
    "code" : "YS",
    "name" : "Composite packaging, glass receptacle in wooden box",
    "bulk" : false
  },
  {
    "code" : "YT",
    "name" : "Composite packaging, glass receptacle in plywood drum",
    "bulk" : false
  },
  {
    "code" : "YV",
    "name" : "Composite packaging, glass receptacle in wickerwork hamper",
    "bulk" : false
  },
  {
    "code" : "YW",
    "name" : "Composite packaging, glass receptacle in fibre drum",
    "bulk" : false
  },
  {
    "code" : "YX",
    "name" : "Composite packaging, glass receptacle in fibreboard box",
    "bulk" : false
  },
  {
    "code" : "YY",
    "name" : "Composite packaging, glass receptacle in expandable plastic pack",
    "bulk" : false
  },
  {
    "code" : "YZ",
    "name" : "Composite packaging, glass receptacle in solid plastic pack",
    "bulk" : false
  },
  {
    "code" : "ZA",
    "name" : "Intermediate bulk container, paper, multi-wall",
    "bulk" : false
  },
  {
    "code" : "ZB",
    "name" : "Bag, large",
    "bulk" : false
  },
  {
    "code" : "ZC",
    "name" : "Intermediate bulk container, paper, multi-wall, water resistant",
    "bulk" : false
  },
  {
    "code" : "ZD",
    "name" : "Intermediate bulk container, rigid plastic, with structural equipment, solids",
    "bulk" : false
  },
  {
    "code" : "ZF",
    "name" : "Intermediate bulk container, rigid plastic, freestanding, solids",
    "bulk" : false
  },
  {
    "code" : "ZG",
    "name" : "Intermediate bulk container, rigid plastic, with structural equipment, pressurised",
    "bulk" : false
  },
  {
    "code" : "ZH",
    "name" : "Intermediate bulk container, rigid plastic, freestanding, pressurised",
    "bulk" : false
  },
  {
    "code" : "ZIS",
    "name" : "Zis",
    "bulk" : false
  },
  {
    "code" : "ZJ",
    "name" : "Intermediate bulk container, rigid plastic, with structural equipment, liquids",
    "bulk" : false
  },
  {
    "code" : "ZK",
    "name" : "Intermediate bulk container, rigid plastic, freestanding, liquids",
    "bulk" : false
  },
  {
    "code" : "ZL",
    "name" : "Intermediate bulk container, composite, rigid plastic, solids",
    "bulk" : false
  },
  {
    "code" : "ZM",
    "name" : "Intermediate bulk container, composite, flexible plastic, solids",
    "bulk" : false
  },
  {
    "code" : "ZN",
    "name" : "Intermediate bulk container, composite, rigid plastic, pressurised",
    "bulk" : false
  },
  {
    "code" : "ZP",
    "name" : "Intermediate bulk container, composite, flexible plastic, pressurised",
    "bulk" : false
  },
  {
    "code" : "ZQ",
    "name" : "Intermediate bulk container, composite, rigid plastic, liquids",
    "bulk" : false
  },
  {
    "code" : "ZR",
    "name" : "Intermediate bulk container, composite, flexible plastic, liquids",
    "bulk" : false
  },
  {
    "code" : "ZS",
    "name" : "Intermediate bulk container, composite",
    "bulk" : false
  },
  {
    "code" : "ZT",
    "name" : "Intermediate bulk container, fibreboard",
    "bulk" : false
  },
  {
    "code" : "ZU",
    "name" : "Intermediate bulk container, flexible",
    "bulk" : false
  },
  {
    "code" : "ZUS",
    "name" : "Unts",
    "bulk" : false
  },
  {
    "code" : "ZV",
    "name" : "Intermediate bulk container, metal, other than steel",
    "bulk" : false
  },
  {
    "code" : "ZW",
    "name" : "Intermediate bulk container, natural wood",
    "bulk" : false
  },
  {
    "code" : "ZX",
    "name" : "Intermediate bulk container, plywood",
    "bulk" : false
  },
  {
    "code" : "ZY",
    "name" : "Intermediate bulk container, reconstituted wood",
    "bulk" : false
  },
  {
    "code" : "ZZ",
    "name" : "Mutually defined",
    "bulk" : false
  }
]
